import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  public showPWA: boolean;
  public showFooter: boolean;

  constructor(
    private router: Router
  ) {
    this.showPWA = !!~['android', 'ios'].indexOf(localStorage.s) ? false : true;

    this.validateUrl(this.router.url);
    this.router.events.subscribe(event => { event instanceof NavigationEnd && this.validateUrl(event.urlAfterRedirects) });
  }

  ngOnInit(): void { }

  private validateUrl(url: string) {
    this.showFooter = !~['voucher'].indexOf(url.replace('/', '').split('?')[0].split('/')[0]);
  }

}
